import { render } from "./PostsDashboard.vue?vue&type=template&id=64549b8b"
import script from "./PostsDashboard.vue?vue&type=script&lang=js"
export * from "./PostsDashboard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/ravanjeyhan-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__